import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { ProductSaleFormType } from '../components/form-type';

export default function useRecalculate() {
  const { control, setValue } = useFormContext<ProductSaleFormType>();
  const [productSales, otherCost, discount] = useWatch({
    control,
    name: ['productSales', 'otherCost', 'discount'],
  });

  const data = React.useMemo(() => {
    const subtotal = productSales.reduce((prev, ps) => {
      const qty = ps.qty || 0;
      const price = ps.price || 0;

      return prev + price * qty;
    }, 0);
    const total = subtotal + (otherCost || 0) - (discount || 0);

    setValue('total', total);

    return {
      subtotal,
      otherCost,
      discount,
      total,
    };
  }, [productSales, discount, otherCost, setValue]);

  return data;
}
